import type { Selection } from '../../hooks/useSelection.js';

export type SelectAllState = { checked: boolean; indeterminate: boolean };

/**
 * The grid header's select-all checkbox: checked once every loaded row is selected, indeterminate
 * once some are — `StudiosGrid` and `GamesGrid` computed this identically.
 */
export const selectAllState = <T extends { type: string; key: string }>(
    rows: readonly T[],
    selection: Selection,
): SelectAllState => {
    const checked = rows.length > 0 && rows.every((row) => selection.has(row));
    const someSelected = rows.some((row) => selection.has(row));
    return { checked, indeterminate: someSelected && !checked };
};
